import { article as futureOfAI } from './01-future-of-artificial-intelligence/blog';
import { article as digitalMinimalism } from './02-philosophy-of-digital-minimalism/blog';
import { article as colorTheory } from './03-science-of-color-theory-in-design/blog';
import { article as storytelling } from './04-art-of-storytelling-in-business/blog';
import { article as digitalArt } from './05-renaissance-of-digital-art/blog';
import { article as digitalNecromancy } from './06-digital-necromancy-ai-resurrecting-dead-internet/blog';
import { article as kastecharaPakhi } from './07-kastechara-pakhi/blog';
import { article as sampleArticle } from './08-sample-article-with-images/blog';
import { article as mrityurBhumika } from './09-manusher-jibone-mrityur-bhumika/blog';
import { article as platosForm } from './10-platos-form-roger-penrose-foundation-mathematics/blog';
import { article as rajDorbar } from './11-raj-dorbar/blog';
import { article as stevenWolfram } from './12-steven-wolfram-computational-worldview/blog';
import { article as hegelMasterSlave } from './13-hegel-master-slave-dialectic/blog';
import { article as arohirSandhyagiti } from './14-arohir-sandhyagiti/blog';

export interface BlogPost {
  id: number;
  title: string;
  slug: string;
  date: string;
  excerpt: string;
  content: string;
  author: string;
  readTime: string;
  category: string;
  tags: string[];
  language: 'english' | 'bengali';
}

const articles = [
  futureOfAI,
  digitalMinimalism,
  colorTheory,
  storytelling,
  digitalArt,
  digitalNecromancy,
  kastecharaPakhi,
  sampleArticle,
  mrityurBhumika,
  platosForm,
  rajDorbar,
  stevenWolfram,
  hegelMasterSlave,
  arohirSandhyagiti
];

const articleVisibility: Record<string, boolean> = {
  [futureOfAI.slug]: false,
  [digitalMinimalism.slug]: false,
  [colorTheory.slug]: false,
  [storytelling.slug]: false,
  [digitalArt.slug]: false,
  [digitalNecromancy.slug]: false,
  [kastecharaPakhi.slug]: false,
  [sampleArticle.slug]: false,
  [mrityurBhumika.slug]: true,
  [platosForm.slug]: false,
  [rajDorbar.slug]: false,
  [stevenWolfram.slug]: true,
  [hegelMasterSlave.slug]: true,
  [arohirSandhyagiti.slug]: true
};

export const blogPosts = articles.filter(article => articleVisibility[article.slug] ?? true);

export const categories = [
  'All',
  'Science',
  'Technology',
  'Philosophy',
  'Arts',
  'Business',
  'Nature'
];

export const getBlogPostBySlug = (slug: string) => {
  return blogPosts.find(post => post.slug === slug);
};
